<template>
  <div id="baojingqushi"></div>
</template>
<script>
import pencer from "./percent";
export default {
  components: {
    pencer,
  },
  data() {
    return {
      searchItem: {
        "endTime": 0,
        "startTime": 0
      },
      animate: false,
      percent: [],
      item: {
        dataList: []
      },
      big: 20,
    };
  },
  methods: {
    reach(v) {
      this.searchItem.startTime = v.start - 86400000;
      this.searchItem.endTime = v.end - 86400000;
      this.getData();
    },

    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-dpc/board/countApplyStart",
        //url: this.axios.ipPort + "/cloud-car-server-upf/data/countAlarmTrend",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        data.alarmList = data.totalList;
        var time = data.dateList;
        for (let j = 0; j < time.length; j++) {
          time[j] = this.utils.time(time[j], "mmdd");
        }
        this.item = data;
        //console.log('派车工单', this.item);
        this.drawBar();
      });
    },
    drawBar() {
      this.chart = this.echarts.init(
        document.getElementById("baojingqushi"),
        "dark"
      );

      this.option = {
        backgroundColor: "",
        grid: {
          x: 30,
          y: 30,
          x2: 30,
          y2: 60, //距离下边的距离

        },
         dataZoom: [
          {
            type: "inside",
            //type: "slider",
            start: 0, //放大起点
            //end: this.list.length<500?100:100/(this.list.length/500) //放大终点
            end: 100, //放大终点
          },
        ],
        xAxis: {
          type: "category",

          data: this.item.dateList,
          axisLabel: { rotate: 45, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: { rotate: 0, color: "#999" },
          axisLine: {
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
          axisTick: {
            show: true,
            lineStyle: {
              color: "#999", //线条颜色
            },
          },
        },
        color: ["#5fc6ec", "yellow"],
        series: [
          {
            data: this.item.alarmList,
            type: "line",
            smooth: 0.5,
            // 设置折线上圆点大小
            symbolSize: 16,
            label: {
              show: true,
              position: "top",
            },
            itemStyle: {
              normal: {
                // color: "#6cb041",
                lineStyle: {
                  width: 2, //设置线条粗细
                },
              },
            },
            /* areaStyle: {
              //color: "#ff7c25",
              opacity: "0.9",
              //shadowColor: "#000",
              // shadowBlur: 50,
              //shadowOffsetX:0,
              // shadowOffsetY:-10
              color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#0b0b60",
                },
                {
                  offset: 1,
                  color: "#000001",
                },
              ]),
            }, */
          },
        ],
        tooltip: {
          //工具提示
          left: 20,
          formatter: function (val) {
            return val.name + "（" + val.value + "）";
          },
        },
      };
      this.chart.setOption(this.option);
      this.chart.resize();
    },

  },
};
</script>
<style>
#baojingqushi {
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/youhao.vue